import { useEffect } from 'react';

export const sendHotJarEvent = (
  event: string,
  data?: Record<string, unknown>,
) => {
  window.hj ||= function () {
    // eslint-disable-next-line prefer-rest-params
    (hj.q = hj.q || []).push(arguments);
  };

  window.hj('event', event, data);
};

export const useHotjarEvent = (event: string) => {
  useEffect(() => {
    sendHotJarEvent(event);
  }, [event]);
};
